import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = kg. */
export const MASS_PIVOT: Record<string, number> = {
  kg: 1,
  g: 0.001,
  mg: 1e-6,
  t: 1000,
  oz: 0.0283495,
  lb: 0.453592,
  ton: 907.185,
};

export const transformMass = createPivotTransformer(MASS_PIVOT);
